package com.essntl.core.utils.io

import com.mohamedrejeb.calf.io.KmpFile

actual fun saveToTempFile(byteArray: ByteArray, extension: String): String? = null

actual fun KmpFile.saveToFile(byteArray: ByteArray) {
    println("Warning: saveToFile is not supported on this platform.")
}